import { PanelBody } from 'components/panel';
import ResultsTableWaiting from 'containers/pages/results/table/ResultsTableWaiting';
import { useResultsPanelContext } from 'contexts/ResultsPanelContext';
import ResultsTable from 'containers/pages/results/table/ResultsTable';

const ResultsPanel = () => {
  const { loading } = useResultsPanelContext();

  return (
    <PanelBody
      scrollHorizontal
      tabIndex="-1" // De scroller veroorzakt een focusable element 🤔
    >
      {loading ? <ResultsTableWaiting /> : <ResultsTable />}
    </PanelBody>
  );
};

export default ResultsPanel;
